let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7XIZw"), load("11tIB"), load("iJSfi"), load("3K8Y5"), load("aZinD"), load("euA5f")]).then(() => parcelRequire('bZz8I'));